/**
 * Utilidades para resolver la ubicación de una entrada.
 *
 * El backend expone la ubicación de dos formas distintas según el recinto:
 *  - Formato plano:   `zona`, `fila`, `seat`
 *  - Formato plaza:   `zona_plaza`, `fila_plaza`, `butaca_plaza`, `nombre_plaza`, `num_plaza`
 *
 * En el formato plaza, `fila_plaza` y `butaca_plaza` pueden venir a null
 * (plazas sin fila), en cuyo caso se usa `nombre_plaza` como referencia.
 */

function hasValue(value) {
    return value !== null && value !== undefined && value !== '';
}

/**
 * Devuelve la zona de la entrada soportando ambos formatos.
 * @param {object} ticket
 * @returns {string}
 */
export function formatZonaTicket(ticket) {
    if (!ticket) return '';

    return ticket.zona_plaza || ticket.zona || '';
}

/**
 * Devuelve la fila/asiento de la entrada soportando ambos formatos.
 * @param {object} ticket
 * @returns {string}
 */
export function formatAsientoTicket(ticket) {
    if (!ticket) return '';

    if (hasValue(ticket.fila_plaza) || hasValue(ticket.butaca_plaza)) {
        return `${hasValue(ticket.fila_plaza) ? ticket.fila_plaza : '-'} / ${hasValue(ticket.butaca_plaza) ? ticket.butaca_plaza : '-'}`;
    }

    if (hasValue(ticket.fila) || hasValue(ticket.seat)) {
        return `${hasValue(ticket.fila) ? ticket.fila : '-'} / ${hasValue(ticket.seat) ? ticket.seat : '-'}`;
    }

    return ticket.nombre_plaza || '';
}
